(() => {
  const dataEl = document.getElementById('documents-data');
  const container = document.getElementById('documentContainer');
  const searchInput = document.getElementById('searchInput');
  const productFilter = document.getElementById('productFilter');
  const typeFilter = document.getElementById('typeFilter');
  const langueFilter = document.getElementById('langueFilter');

  let docs = [];
  let timer;

  const typeVisuals = {
    LL: { color: '#e74c3c', icon: 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.4.0/svgs/solid/triangle-exclamation.svg' },
    'Fiche technique': { color: '#2980b9', icon: 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.4.0/svgs/solid/chart-bar.svg' },
    FDS: { color: '#27ae60', icon: 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.4.0/svgs/solid/cogs.svg' },
    Catalogue: { color: '#8e44ad', icon: 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.4.0/svgs/solid/book-open.svg' },
    Parametre: { color: '#f39c12', icon: 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.4.0/svgs/solid/certificate.svg' },
    Protocol: { color: '#1abc9c', icon: 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.4.0/svgs/solid/file-lines.svg' }, // Ajouté pour Protocol
    default: { color: '#777', icon: 'https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.4.0/svgs/solid/file-lines.svg' },
  };

  function populateFilters() {
    // Nettoyage des types pour les filtres (enlève les crochets et guillemets)
    const products = [...new Set(docs.map((d) => d.produitTitle))].sort();
    const types = [...new Set(docs.flatMap((d) => String(d.type).replace(/[\[\]"]/g, '').split(',').map((t) => t.trim())))].sort();
    const langues = [...new Set(docs.flatMap((d) => String(d.langue).replace(/[\[\]"]/g, '').split(',').map((t) => t.trim())))].sort();

    products.forEach((p) => productFilter.add(new Option(p, p)));
    types.forEach((t) => typeFilter.add(new Option(t, t)));
    langues.forEach((l) => langueFilter.add(new Option(l, l)));
  }

  function render() {
    const term = searchInput.value.toLowerCase();
    const prod = productFilter.value;
    const typ = typeFilter.value;
    const lang = langueFilter.value;

    const filtered = docs.filter(
      (d) => {
        const cleanType = String(d.type).replace(/[\[\]"]/g, ''); // Nettoyage ici aussi pour la logique de filtrage
        return d.nomLower.includes(term) &&
        (!prod || d.produitTitle === prod) &&
        (!typ || cleanType.split(',').map((t) => t.trim()).includes(typ)) &&
        (!lang || d.langue.split(',').map((l) => l.trim()).includes(lang));
      }
    );

    

    container.innerHTML =
      filtered
        .map((d) => {
          // Nettoyage du texte pour l'affichage (ex: ["Protocol"] -> Protocol)
          const displayType = String(d.type).replace(/[\[\]"]/g, '').trim();
          const visual = typeVisuals[displayType] || typeVisuals.default;
          
          return `
            <div class="card">
              <header class="card-header">
                <img class="card-icon" src="${visual.icon}" alt="" loading="lazy" />
                <span class="badge" style="background: ${visual.color}">${displayType}</span>
              </header>
              <h3 class="card-title">
                <a href="${d.url}" target="_blank" rel="noopener">${d.nom}</a>
                <p>${d.description_courte}</P>
              </h3>
              <div class="meta">${d.produitTitle} — ${d.dateAffiche}</div>
              <a class="btn-view" href="${d.url}" target="_blank" rel="noopener">Voir le document</a>
            </div>`;
        })
        .join('') || '<p>Aucun document ne correspond à vos critères.</p>';

    container.setAttribute('aria-live', 'polite');
  }

  function init() {
    try {
      docs = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Erreur de parsing JSON', e);
      return;
    }
    populateFilters();
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(render, 300);
    });
    [productFilter, typeFilter, langueFilter].forEach((f) => f.addEventListener('change', render));
    render();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
